/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

const ERRORS = {
  "appendedUserSuggestion": "Please try reloading the application or trying again later. If this issue persist, report it as an issue.",
  "applicationServersUnavailabe": "Unable to connect with application servers.",
  "authenticationServiceUnavailable": "Unable to connect to the authentication service.",
  "badRequest": "Invalid request parameters.",
  "databaseConnectionUnavailable": "Unable to connect to the database service.",
  "databaseValueIdentical": "Value is identical to database value. At least 1 change must be made.",
  "databaseValueNotFound": "Invalid database key. Value not found.",
  "contactServiceUnavailable": "Unable to connect to the contact service.",
  "passwordResetServiceUnavailable": "Unable to connect to the password reset service.",
  "permissionNotFound": "Invalid permissions key. Value not found.", 
  "storageConnectionUnavailable": "Unable to connect to the storage service.",
  "userIdentityConflict": "User identity not present on domain.",
  "userIdentityToken": "Invalid user identity token.",
  "userIdentity": "Invalid user associated with identity token.",
  "userPermissions": "User does not have permissions to access this resource."
};
export default ERRORS;
